var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"request_customers"},[_c('div',{staticClass:"request_customers_title"},[_vm._v("Join the industry trailblazers already using Contrimetric")]),_c('CustomerList',{attrs:{"isShowTitle":false,"isShowStatistics":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }